import React from "react";
import { getSafeMediaAssetUrl } from "@qlik/qlik/src/lib/util/helpers";
import Media from "@qlik/qlik/src/components/Media";
import Image from "@qlik/qlik/src/components/Image";
import Cta from "@qlik/qlik/src/components/Cta";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import * as styles from "./styles.module.css";

/**
 * ClickableImageComponent is a component that displays a clickable image.
 * @param {Object} data - The data for the clickable image component.
 */
const ClickableImageComponent = ({ data }) => {
    const { additionalConfiguration, mediaAsset, cardItems = [], customId } = data ?? {};
    // Get the safe URL for the media asset
    const logo = getSafeMediaAssetUrl(mediaAsset, 0);
    // Get the class name for the section padding
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "lg:py-30");

    return (
        <section className={` ${sectionSpacingClassName} clickable_image_component`} id={customId}>
            <div className="container">
                <div className="top-image">
                    {/* Display the image */}
                    <Image link={logo} className="w-full" />
                </div>
                <ul className="card-list list-none flex flex-row flex-wrap justify-center md:justify-between">
                    {/* Map through the card items and display each one */}
                    {cardItems?.map((card) => (
                        <li
                            key={card.id}
                            className={`${styles.card} card p-0 bg-none after:hidden max-w-[142px] md:max-w-[173px] lg:max-w-[142px] xl:max-w-full w-[164px] last:max-w-full last:w-full`}
                        >
                            {/* eslint-disable-next-line react/jsx-no-target-blank */}
                            <Cta data={card?.cta?.[0]}>
                                {/* If the card has media, display it */}
                                <div className="overflow-hidden rounded">
                                    <div
                                        className={`transition-transform duration-300 ease-in-out ${
                                            card === data.cardItems[data.cardItems.length - 1]
                                                ? ""
                                                : "xl:group-hover:scale-105"
                                        }`}
                                    >
                                        {card?.media?.[0] && (
                                            <Media media={card?.media?.[0]} className="w-100 rounded" />
                                        )}
                                    </div>
                                </div>
                            </Cta>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
};

export default ClickableImageComponent;
